import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Pricing from '../components/Pricing/Pricing'
import Contactfooter from '../components/Contactfooter'

const Pricingpage = () => {
    return (
        <div>
        <Navbar/>
        <Pricing/>
        <Contactfooter/>


        <Footer/>

        </div>
    )
}

export default Pricingpage